import { QueryClient, QueryCache, keepPreviousData } from '@tanstack/react-query';
import { toast } from '~/hooks/use-toast';
import { ToastAction } from '~/components/ui/Toast';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const isNetworkError = error.message.toLowerCase().includes('failed to fetch');
      if (isNetworkError) return;

      toast({
        variant: 'destructive',
        title: 'Failed to load data',
        description: error.message || 'Something went wrong. Please try again.',
        action: (
          <ToastAction
            altText="Retry"
            onClick={() =>
              queryClient.invalidateQueries({ queryKey: query.queryKey })
            }
          >
            Retry
          </ToastAction>
        ),
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10,
      gcTime: 1000 * 60 * 60,
      refetchOnMount: true,
      refetchOnReconnect: 'always',
      placeholderData: keepPreviousData,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
